module.exports = __webpack_public_path__ + "img/20190615103805824.1fb7fa54.png";